import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { UiService } from 'src/app/_services/ui.service';
import { UserTransactionsService } from 'src/app/_services/user/transactions.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {
  redirect = '';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apollo: Apollo,
    private ui: UiService,
    private auth: AuthenticationService,
    private dialogRef: MatDialog,
    private userTransactions: UserTransactionsService,
  ) {
    this.mjau();
  }
  async mjau() {
    this.userTransactions.pendingTransId = null;
    this.userTransactions.resetRefetchQuery();
    await this.apollo.client.clearStore();

    localStorage.removeItem('currentUser');
    this.auth.user = null;
    this.auth.authToken = null;
    this.redirect = this.route.snapshot.paramMap.get('redirect');
    this.redirect = this.redirect ? this.redirect : '/'
    this.dialogRef.closeAll()
    // this.router.navigateByUrl(this.redirect)
    window.location.href = this.redirect ? this.redirect : '/';

    // if (document.visibilityState == "visible") {
    //   this.dialogRef.closeAll();
    // } else {

    //   setTimeout(() => { window.location.reload(); }, 300)
    // }



    // if (redirect) {
    //   this.router.navigate(["/" + redirect]);
    // } else {
    //   this.router.navigate(["/login"]);
    // }
  }
}
